module.exports = __webpack_public_path__ + "img/map.ccbe1510.png";